import { createBrowserHistory } from 'history'

/**
 * @description
 * Allows history functions to be used outside of functional components.
 *
 * Use this where you would normally use: __import history from 'react-router-dom'__
 */
export const history = createBrowserHistory()
